import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

export const deleteOrder = async (orderID) => {
  const { userID, token } = useCurrentUser();
  const apiURL = `${API_HOST}/orders/delete_order?order_id=${orderID}`;

  try {
    const { data } = await axios.delete(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error('Error deleting order:', error);
    return null;
  }
};
